'use client'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { FormEvoIcon } from '@repo/ui/FormEvoIcon'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUrlStore } from '@repo/store/useUrlStore'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

export const FormEvoCallback = () => {
  const { queryParams } = useUrlStore()
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (queryParams?.success === true || queryParams?.success === 'true') {
      setSuccess(true)
      setMessage(
        'Your FormEvo integration has been set up successfully! You can now access FormEvo forms within Osprey.'
      )
    } else {
      setSuccess(false)
      setMessage('There was an error setting up your FormEvo integration. Please try again.')
    }
  }, [queryParams])

  const handleClickToTryAgain = () => {
    navigate('/configuration/third-party-forms')
  }

  return (
    <MUIStack
      data-testid="FormEvoCallback"
      gap={6}
      sx={{ maxWidth: 680, margin: 'auto', backgroundColor: 'white', borderRadius: '6px', padding: '60px 40px' }}
    >
      <FormEvoIcon sx={{ width: 220, height: 55 }} />
      <MUITypography variant="body1">{message}</MUITypography>

      {!success ? (
        <MUIButton
          variant="contained"
          color="primary"
          size="large"
          onClick={handleClickToTryAgain}
          sx={{ maxWidth: 160, width: '100%', margin: '20px 0 0 auto' }}
        >
          <ChevronRightIcon sx={{ color: 'white', transform: 'rotate(180deg)' }} />
          Back
        </MUIButton>
      ) : null}
    </MUIStack>
  )
}
